import { ElementRef, Component, Input, HostBinding, Renderer2, ContentChild } from '@angular/core';
import { guid } from '../common/dom-utils';
import { TextBoxDirective } from './textbox.directive';
/**
 * Represents the Kendo UI TextBox component for Angular.
 *
 * Provides floating labels to `input` elements.
 *
 * @example
 * ```ng-template
 * <kendo-textbox-container floatingLabel="First name">
 *   <input kendoTextBox />
 * </kendo-textbox-container>
 * ```
 */
var TextBoxContainerComponent = (function () {
    function TextBoxContainerComponent(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        /**
         * @hidden
         */
        this.focused = false;
        /**
         * @hidden
         */
        this.empty = true;
        this._listeners = [];
        this.renderer.removeAttribute(this.elementRef.nativeElement, "id");
    }
    Object.defineProperty(TextBoxContainerComponent.prototype, "hostClasses", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextBoxContainerComponent.prototype, "focusedClass", {
        get: function () {
            return this.focused;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextBoxContainerComponent.prototype, "emptyClass", {
        get: function () {
            return this.empty;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    TextBoxContainerComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (!this.textbox) {
            return;
        }
        var input = this.textbox.nativeElement;
        input.classList.add("k-textbox-no-border");
        this.empty = !input.value;
        this.listen(input, 'focus', function () { return _this.focused = true; });
        this.listen(input, 'blur', function () { return _this.focused = false; });
        this.listen(input, 'input', function (e) { return _this.empty = !e.srcElement.value; });
        if (this.id && input.id) {
            // input wins
            this.id = input.id;
        }
        else if (this.id) {
            input.id = this.id;
        }
        else if (input.id) {
            this.id = input.id;
        }
        else {
            var id = "_" + guid();
            input.id = id;
            this.id = id;
        }
    };
    /**
     * @hidden
     */
    TextBoxContainerComponent.prototype.ngOnDestroy = function () {
        this._listeners.forEach(function (listener) { return listener(); });
        this._listeners = [];
    };
    /**
     * @hidden
     */
    TextBoxContainerComponent.prototype.listen = function (element, eventName, handler) {
        var listener = this.renderer.listen(element, eventName, handler);
        this._listeners.push(listener);
    };
    return TextBoxContainerComponent;
}());
export { TextBoxContainerComponent };
TextBoxContainerComponent.decorators = [
    { type: Component, args: [{
                selector: 'kendo-textbox-container',
                template: "\n    <ng-content></ng-content>\n    <label *ngIf=\"floatingLabel\" [for]=\"id\" class=\"k-label\">{{ floatingLabel }}</label>\n  "
            },] },
];
/** @nocollapse */
TextBoxContainerComponent.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: Renderer2, },
]; };
TextBoxContainerComponent.propDecorators = {
    'hostClasses': [{ type: HostBinding, args: ['class.k-textbox-container',] },],
    'focusedClass': [{ type: HostBinding, args: ['class.k-state-focused',] },],
    'emptyClass': [{ type: HostBinding, args: ['class.k-state-empty',] },],
    'id': [{ type: Input },],
    'floatingLabel': [{ type: Input },],
    'textbox': [{ type: ContentChild, args: [TextBoxDirective, { read: ElementRef },] },],
};



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-inputs/dist/es/textbox/textbox-container.component.js
// module id = ../../../../@progress/kendo-angular-inputs/dist/es/textbox/textbox-container.component.js
// module chunks = 3